import { AbstractControl, ValidationErrors } from '@angular/forms';
import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js/mobile';
import { isNil } from 'lodash-es';

import { isEmptyString } from '@aw/shared/utilities';

import { isCountryCallingCode } from '../utils/phone-input.utils';

export class PhoneValidators {
  static required(control: AbstractControl): ValidationErrors | null {
    const value = control.value as string | undefined;

    if (isNil(value) || isEmptyString(value) || isCountryCallingCode(value)) {
      return { required: true };
    }

    try {
      const { nationalNumber } = parsePhoneNumber(value);

      if (!nationalNumber) {
        return { required: true };
      }
    } catch (error) {
      if (error === 'TOO_SHORT') {
        return { required: true };
      }
    }

    return null;
  }

  static valid(control: AbstractControl): ValidationErrors | null {
    const value = control.value as string | undefined;

    if (!isNil(value)) {
      const isValid = isValidPhoneNumber(value);

      return isValid ? null : { valid: true };
    }

    return null;
  }
}
